import { render, staticRenderFns } from "./BF.vue?vue&type=template&id=63d6802f&scoped=true&"
import script from "./BF.vue?vue&type=script&lang=js&"
export * from "./BF.vue?vue&type=script&lang=js&"
import style0 from "./BF.vue?vue&type=style&index=0&id=63d6802f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d6802f",
  null
  
)

export default component.exports